import { facebookLink } from './links';

export const gyikData = {
  HU: `# GYIK

1) Hogyan lehet eljutni a helyszínre?

Ha autóval indulnál el a [Malomfesztivál 2025](${facebookLink}) ([Térkép megtekintése](https://goo.gl/maps/vnMpSPLCpZNJifB89))-re, és ha a sátor mellé befér még 1-2 ember is, akkor csatlakozzatok a [MALOMFESZTIVÁL 2025 UTAZZUNK EGYÜTT//SHARED RIDE](https://www.facebook.com/groups/2366320976736373/) csoporthoz és keressetek útitársat magatok mellé.

A Magyarországról érkező vendégek figyelmébe ajánljuk a következő csoportokat:

*   [Vajdaság - Budapest - Vajdaság](https://www.facebook.com/groups/239063002814176/)
*   [Vajdaságból Szegedre](https://www.facebook.com/groups/202749096430149/)
*   [Határfigyelők](https://www.facebook.com/groups/Hatarfigyelok/)

A folyamatos vendégmunkások és a nyaralásra igyekvők ingázása a Balkán felé és vissza lassít(hat)ja a forgalmat. Készüljetek vízzel és induljatok időben! Létrejött egy [Border Watcher](https://play.google.com/store/apps/details?id=com.tools.szt.borderwatcher&amp;hl=en_US&amp;pli=1) app is (Android / iOs), ahol folyamatosan követhetitek a határhelyzetet. Szerbia felé a kis határok használata javasolt:

*   Röszke - Horgoš közút (nyitvatartás: 07:00-19:00)
*   Tiszasziget - Đala (nyitvatartás: 07:00-19:00)
*   Kübekháza - Rábé (nyitvatartás: 07:00-19:00)

Visszafelé pedig (ha éjjeli utazásról van szó) az autópályás Röszke határátkelőt (nyitvatartás: 0-24) avagy a Kelebia-Tompa (nyitvatartás: 0-24 - kisebb kerülő, azonban nem kell órákat várakozni). A határon érvényes magyar személyivel vagy útlevéllel lehet átkelni. Ha tömegközlekedéssel szeretnél eljutni hozzánk, akkor a [https://www.polazak.rs/hu/](https://www.polazak.rs/hu/) weboldala tud segítséget nyújtani.

2) Lehet-e elővételben jegyet vásárolni?

Igen, itt vannak a lehetőségek: [Jegyek](/tickets)

3) Tudok sátorozni? Ha igen, hol és mennyibe kerül?

A fesztivál területén biztosítunk külön sátorhelyet, az oromi medence körül és a bejárat mellett. A táborozás ingyenes.

4) Lehet-e bevinni ételt, italt?

Alkoholos italt semmilyen mennyiségben, alkoholmentes italt igen. Élelmiszert kereskedelmi mennyiséget el nem érő mennyiségben lehet behozni a fesztivál területére. Az ilyen jellegű termékeket a bejáratnál köteles mindenki ellenőrzésre átadni a biztonsági szolgálatnak.

5) Lehet a helyszínen ételt, italt vásárolni?

Igen, több helyszín is várja az éhes és szomjas fesztiválozókat. Vega/vegán konyha is lesz, sör, bor, pálinka, limonádé és ezek keveréke is!

6) Mit nem lehet bevinni?

A Malomfesztivál szervezősége különös figyelmet szentel a látogatók testi épségének védelméért. Ezért ilyen (mások testi épségét veszélyeztető) tárgyakat tilos behozni. A hatályos jogszabályok szerint nem tarthatsz magadnál ún. közbiztonságra különösen veszélyes tárgyat (8 cm-nél nagyobb vágó élű kés, rúgóskés, gázspray, ólmosbot, stb), ez szabálysértésnek minősül.

Ezenkívül tűz- és robbanásveszélyes anyagokat (pl. camping gázpalackot), valamint alkoholtartalmú italt. Szerbiában mind a könnyű, mind pedig a kemény drogok fogyasztása és birtoklása büntetendő cselekmény, ezért a Malomfesztiválra is szigorúan tilos a behozataluk!

7) Milyenek a higiéniás körülmények (zuhanyzó, WC, meleg víz)?

A helyszínen biztosítunk mobil WC-ket. Található a területen épített vizesblokk is, angol WC-vel, és melegvizes tussal. A medencéhez közel zuhanyzási lehetőség is biztosított az általunk épített szabadtéri tusolókban. A zuhany hőmérséklete a nyári időhöz mérten pont megfelelően hűsítő lesz.

8) Lesz felügyelet, biztonsági szolgálat?

A fesztivál egész területén lesz felügyelet, a parkoló- és sátorhelyeknél is, viszont az értéktárgyakért felelősséget nem vállalunk!

9) Hol lehet parkolni? Lesz őrzött parkoló?

A fesztivál területén kívül biztosítunk parkolási lehetőséget. Az értéktárgyakért felelősséget nem vállalunk! A fesztivál területére engedély nélkül szigorúan tilos gépjárművel behajtani.

10) Kihez fordulhatok, ha segítségre van szükségem?

A malomban található információs pultnál készségesen állunk rendelkezésedre. Fordulj bizalommal a szervezőkhöz!

11) Szabad a helyszínen tüzet gyújtani?

A helyszínen tüzet gyújtani SZIGORÚAN TILOS!
`,
  EN: `# FAQ

1) How to approach the destination?

If you're planning to drive to [Malomfesztivál 2025](${facebookLink}) ([View on Map](https://goo.gl/maps/vnMpSPLCpZNJifB89)), and have space for 1-2 more people next to your tent, join the [MALOMFESZTIVÁL 2025 UTAZZUNK EGYÜTT//SHARED RIDE](https://www.facebook.com/groups/2366320976736373/) group and find some travel companions.

For guests coming from Hungary, we recommend the following groups:

*   [Vajdaság - Budapest - Vajdaság](https://www.facebook.com/groups/239063002814176/)
*   [Vajdaságból Szegedre](https://www.facebook.com/groups/202749096430149/)
*   [Határfigyelők](https://www.facebook.com/groups/Hatarfigyelok/)

The constant commuting of guest workers and holiday-goers towards and from the Balkans can slow down traffic. Be prepared with water and start early! There is also a [Border Watcher](https://play.google.com/store/apps/details?id=com.tools.szt.borderwatcher&amp;hl=en_US&amp;pli=1) app (Android / iOS), where you can continuously monitor the border situation. It is recommended to use the smaller border crossings towards Serbia:

*   Röszke II – Horgoš II (open: 04:00–23:00)
*   Tiszasziget - Đala (opening hours: 07:00-19:00)
*   Kübekháza - Rábé (opening hours: 07:00-19:00)

For the return trip (especially if traveling at night), we suggest using the Röszke I -  Horgoš I highway border (open 24/7) or the Kelebija–Tompa crossing (also 24/7 – a small detour, but often with shorter waiting times). You can cross the border with a valid Hungarian ID or any passport.

If you plan to come by public transport, check out https://www.polazak.rs/hu/ for travel options.

2) Can we purchase tickets in advance?

Yes. Here is the link: [Tickets](/tickets)

3) Is camping available? If yes, where and how much does it cost?

We provide a campsite near the swimming pool, the no. 1 crew and community camp for those with Community support tickets, the organizers, volunteers, builders and decorators stay. Campsite no. 2 is at the stubble fields and it is free of charge for all our guests.

4) Is it allowed to bring food and drinks inside?

No alcoholic beverages are allowed in any amount. You may bring food in non-commercial quantities. These items must be presented for inspection at the entrance by security.

5) Can I buy food and drinks on the spot?

Yes, there will be vendors to serve hungry and thirsty festival-goers. Vegetarian/vegan options will be available, as well as beer, wine, rakija/pálinka, lemonade, and fun mixes of all!

6) What items are prohibited?

The Malomfesztivál organizers prioritizes the safety of all visitors. Therefore, it is strictly forbidden to bring items that may endanger others' safety (e.g., knives with blades over 8 cm, switchblades, pepper spray, lead batons, etc). Flammable or explosive materials (e.g., camping gas canisters) are also banned.

In Serbia, both the use and possession of light or hard drugs are criminal offenses, and bringing them to Malomfesztivál is strictly prohibited!

7) What are the hygiene facilities like (showers, toilets, hot water)?

There will be mobile toilets on site. Additionally, a built water block is available with English-style toilets and hot water showers. Outdoor showers will also be available near the pool. The shower temperature will be refreshingly cool for the summer weather.

8) Will there be on-site security?

Security will be present throughout the festival grounds, including at the parking and camping areas. However, we do not take responsibility for your valuables!

9) Where can I park? Will there be secured parking?

Parking will be provided outside the festival grounds. We do not take responsibility for valuables! Driving into the festival area without permission is strictly forbidden.

10) Who can I turn to if I need help?

Visit the info desk in the mill, where our team will be happy to assist you. Feel free to reach out to any of the organizers!

11) Is it allowed to build a fire on site?

Lighting fires is STRICTLY FORBIDDEN at the festival!
`,
  RS: `# FAQ

1) Kako stići do lokacije?

Želiš da dođeš automobilom na [Malomfesztivál 2025](${facebookLink}) ([Pogledaj na mapi](https://goo.gl/maps/vnMpSPLCpZNJifB89)), i pored spakovanog šatora imaš još mesta za osobu ili dve? Pristupi [MALOMFESZTIVÁL 2025 UTAZZUNK EGYÜTT//SHARED RIDE](https://www.facebook.com/groups/2366320976736373/) Fejsbuk grupi i pronađi svoje saputnike!

Za posetioce koji dolaze iz Mađarske, preporučujemo sledeće grupe:

*   [Vajdaság - Budapest - Vajdaság](https://www.facebook.com/groups/239063002814176/)
*   [Vajdaságból Szegedre](https://www.facebook.com/groups/202749096430149/)
*   [Határfigyelők](https://www.facebook.com/groups/Hatarfigyelok/)

Neprekidni prelazak granice radnika i onih koji putuju na odmor ka Balkanu mogu usporiti saobraćaj. Pripremite vodu i krenite na vreme! Takođe postoji aplikacija Border Watcher (Android / iOS), koja vam omogućava da pratite stanje na granici. Preporučuje se korišćenje manjih graničnih prelaza ka Srbiji:

*   Röszke - Horgoš (radno vreme: 04:00-23:00)
*   Tiszasziget - Đala (radno vreme: 07:00-19:00)
*   Kübekháza - Rábé (radno vreme: 07:00-19:00)

Za povratak, ako putujete noću, možete koristiti granični prelaz na autoputu Röszke I - Horgoš I (radno vreme: 0-24) ili Kelebija-Tompa (radno vreme: 0-24 - malo zaobilazno, ali bez dužeg čekanja). Ako planirate da putujete javnim prevozom, pomoć možete dobiti na sajtu https://www.polazak.rs/.


2) Mogu li kupiti karte unapred?

Da, evo opcija za kupovinu karata: [Karte](/tickets)

3) Mogu li kampovati? Ako da, gde i koliko košta?

Na festivalu ćemo obezbediti posebna mesta za kampovanje. Kampovanje je besplatno.

4) Mogu li uneti hranu i piće?

Alkoholna pića u bilo kojoj količini nisu dozvoljena. Hranu je dozvoljeno uneti u količini koja nije komercijalna. Takvi proizvodi će biti podložni kontroli prilikom ulaska koju vrši obezbeđenje.

5) Mogu li kupiti hranu i piće na licu mesta?

Da, biće više lokacija za gladne i žedne posetioce festivala. Biće vegetarijanske/veganske hrane, piva, vina, rakije, limunade i njihovih kombinacija!

6) Šta ne mogu uneti?

Organizatori Malomfesztivála posvećuju posebnu pažnju zaštiti bezbednosti posetilaca. Stoga, zabranjeno je unositi predmete koji mogu ugroziti sigurnost drugih (npr. noževi sa oštrim ivicama dužim od 8 cm, skakavci, biber sprejevi, olovne palice, itd.). Takođe su zabranjeni zapaljivi i eksplozivni materijali (npr. plinske boce za kampovanje). U Srbiji je upotreba i posedovanje lakih i teških droga zabranjeno i kažnjivo, pa je njihov unos na Malomfesztivál takođe strogo zabranjen!

8) Kakvi su higijenski uslovi (tuš, WC, topla voda)?

Na festivalu će biti obezbeđeni mobilni WC-i. Takođe postoje i mokri čvorovi toaletima, sa toplom vodom i tušem. Tuširanje na otvorenom će biti omogućeno u blizini bazena. Temperatura vode u tuševima će biti osvežavajuća za letnje uslove.

9) Da li će biti obezbeđenja, bezbednosne službe?

Na celoj teritoriji festivala biće prisutno obezbeđenje, uključujući parkinge i kamp zone. Međutim, organizatori ne preuzimaju odgovornost za vredne predmete!

10) Gde mogu parkirati? Da li će biti obezbeđen čuvani parking?

Biće obezbeđen parkirang van teritorije festivala. Organizatori ne preuzimaju odgovornost za vredne predmete! Strogo je zabranjeno vozilom ulaziti na teritoriju festivala bez dozvole.

11) Kome mogu da se obratim ako mi je potrebna pomoć?

Za pomoć se možete obratiti na info pultu u mlinu, gde će vam ljubazno pomoći organizatori!

12) Da li je dozvoljeno paljenje vatre na mestu?

Paljenje vatre je STROGO ZABRANJENO na festivalu!
`,
};
